import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from '../models/restResponse.mode';
import { environment } from '../../environments/environment';
import { City } from '../models/city.model';

@Injectable({
  providedIn: 'root'
})
export class CityService {
  private readonly baseUrl = `${environment.base_url}/cities`;

  constructor(private http: HttpClient) {}

  getAll(search: string, stateId: number|null, acronym: string | null, paginate: boolean | null, page: number | null): Observable<RestResponse<City[]>> {
    return this.http.get<RestResponse<City[]>>(`${this.baseUrl}/list?search=${search}&stateId=${stateId}&stateAcronym=${acronym}&paginate=${paginate}&page=${page}`);
  }

  getById(id: number): Observable<RestResponse<City>> {
    return this.http.get<RestResponse<City>>(`${this.baseUrl}/find/${id}`);
  }

  create(City: City): Observable<City> {
    return this.http.post<City>(`${this.baseUrl}/save`, City);
  }

  update(id: number, City: City): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/update/${id}`, City);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
  
}
